/* src/app/components/back-button-component/back-button-component.css */
.page-back-row {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 18px;
}
@media (max-width: 768px) {
  :host {
    display: none;
  }
}
/*# sourceMappingURL=back-button-component.css.map */
